<template>
  <el-dialog
    :title="form.id > 0 ? '编辑物资调拨' : '添加物资调拨'"
    :visible.sync="visible"
    width="1100px"
    @close="$emit('update:show', false)"
    @open="handleOpen"
    :close-on-click-modal="false"
  >
    <el-form
      v-if="visible"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="mini"
      class="supply-form"
    >
      <el-form-item label="接发地类型">
        <el-select v-model="form.entity_type" size="small" style="width: 100%">
          <el-option :value="1" key="1" label="基地 发往 基地"></el-option>
          <el-option :value="2" key="2" label="基地 发往 钻井"></el-option>
          <el-option :value="3" key="3" label="钻井 发往 基地"></el-option>
          <el-option :value="4" key="4" label="钻井 发往 钻井"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="发起基地"
        prop="base_id"
        v-if="[1, 2].includes(form.entity_type)"
      >
        <BaseSelect
          v-model="form.base_id"
          :filterBlank="true"
          :authLimit="true"
        ></BaseSelect>
      </el-form-item>
      <el-form-item label="发起钻井" prop="drill_well_id" v-else>
        <DrillWellSelect
          v-model="form.drill_well_id"
          :filterBlank="true"
          :authLimit="true"
        ></DrillWellSelect>
      </el-form-item>
      <el-form-item
        label="接收基地"
        prop="approve_base_id"
        v-if="[1, 3].includes(form.entity_type)"
      >
        <BaseSelect
          v-model="form.approve_base_id"
          :filterBlank="true"
        ></BaseSelect>
      </el-form-item>
      <el-form-item label="接收钻井" prop="receive_well_id" v-else>
        <DrillWellSelect
          v-model="form.receive_well_id"
          :filterBlank="true"
        ></DrillWellSelect>
      </el-form-item>
      <el-form-item label="单据类型" prop="category">
        <ItemStatusSelect
          class="long"
          v-model="form.category"
          model="supplyCategory"
        ></ItemStatusSelect>
      </el-form-item>
      <el-form-item label="发出时间" prop="send_date">
        <el-date-picker
          style="width: 100%"
          v-model="form.send_date"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择"
          size="small"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发货方式" prop="delivery_category">
        <ItemStatusSelect
          class="long"
          v-model="form.delivery_category"
          model="supplyDelivery"
        ></ItemStatusSelect>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          autocomplete="off"
          maxlength="200"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件" class="long" prop="attachments">
        <AttachmentUpload v-model="form.attachments"></AttachmentUpload>
      </el-form-item>
      <el-form-item label="物资明细" style="width: 100%" v-if="form.items">
        <div>共 {{ form.items.length }} 件</div>
        <el-table border :data="form.items" size="mini">
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center"
          />
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.category" size="small">
                <el-option
                  v-for="(k, v) in ApplyItemCategoryMap"
                  :key="v"
                  :label="k"
                  :value="parseInt(v)"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="名称" align="center">
            <template slot-scope="scope">
              <ProductTemplateSelect
                key="apply_category_1"
                v-if="scope.row.category == 1"
                :category="1"
                v-model="scope.row.product_template_id"
              ></ProductTemplateSelect>
              <ItemTemplateSelect
                key="apply_category_2"
                v-else-if="scope.row.category == 2"
                :category="1"
                v-model="scope.row.item_template_id"
              ></ItemTemplateSelect>
              <ProductTemplateSelect
                key="apply_category_3"
                v-else-if="scope.row.category == 3"
                :category="2"
                v-model="scope.row.product_template_id"
                :clearable="true"
                :all="true"
              ></ProductTemplateSelect>
              <ItemTemplateSelect
                key="apply_category_4"
                v-else-if="scope.row.category == 4"
                :category="2"
                :clearable="true"
                v-model="scope.row.item_template_id"
              ></ItemTemplateSelect>
            </template>
          </el-table-column>
          <el-table-column label="编号" align="center">
            <template slot-scope="scope">
              <el-form-item
                :prop="`items[${scope.$index}].product_id`"
                :rules="rules.product_id"
                style="width: 100%"
                v-if="scope.row.category == 3"
              >
                <ProductSelect
                  v-model="scope.row.product_id"
                  @info="handleInfo($event, scope.$index, 'product')"
                  :templateid="scope.row.product_template_id || 0"
                  :baseid="form.base_id || 0"
                  :wellid="form.drill_well_id || 0"
                  :category="2"
                  :transfer="true"
                  :codeType="0"
                ></ProductSelect>
              </el-form-item>
              <el-form-item
                :prop="`items[${scope.$index}].item_id`"
                :rules="rules.item_id"
                style="width: 100%"
                v-if="scope.row.category == 4"
              >
                <ItemSelect
                  v-model="scope.row.item_id"
                  @info="handleInfo($event, scope.$index, 'item')"
                  :templateid="scope.row.item_template_id || 0"
                  :category="2"
                  :singleSelect="true"
                  :baseid="form.base_id || 0"
                  :wellid="form.drill_well_id || 0"
                  :transfer="true"
                  ref="itemSelect"
                ></ItemSelect>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="规格型号" align="center" prop="spec">
          </el-table-column>
          <el-table-column label="销售地" align="center" prop="saleby">
          </el-table-column>
          <el-table-column label="特性1" align="center" prop="feature1">
          </el-table-column>
          <el-table-column
            label="工作时长"
            align="center"
            v-if="form.category == 2"
            width="90"
          >
            <template slot-scope="scope">
              <el-form-item
                :prop="`items[${scope.$index}].used_date`"
                :rules="rules.used_date"
                style="width: 100%"
              >
                <el-input-number
                  v-model="scope.row.used_date"
                  :controls="false"
                  :min="0"
                ></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="返厂原因"
            align="center"
            v-if="form.category == 2"
          >
            <template slot-scope="scope">
              <el-form-item
                style="width: 100%"
                :prop="`items[${scope.$index}].return_reason`"
                :rules="rules.return_reason"
              >
                <el-input
                  style="width: 100%"
                  v-model="scope.row.return_reason"
                  size="small"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="数量" align="center" width="90">
            <template slot-scope="scope">
              <el-form-item
                v-if="scope.row.number > 0"
                :prop="`items[${scope.$index}].number`"
                :rules="rules.number"
                style="width: 100%"
              >
                <el-input-number
                  v-model="scope.row.number"
                  :controls="false"
                  :min="1"
                ></el-input-number>
              </el-form-item>
              <template v-else>1</template>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-link
                slot="reference"
                type="danger"
                class="font-12"
                :underline="false"
                @click="form.items.splice(scope.$index, 1)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="display: inline-block">
          添加行数
          <el-input-number
            v-model="addItemCount"
            :controls="false"
            :min="1"
            :max="100"
          >
          </el-input-number>
        </div>
        <el-button
          class="mt-10 ml-10"
          size="mini"
          type="primary"
          @click="handleAddItem"
          >添加物资</el-button
        >
        <el-button
          class="mt-10"
          size="mini"
          type="primary"
          @click="handleSelectApply"
          >从调拨单添加</el-button
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submitting"
        @click="submitForm"
        >保 存</el-button
      >
    </div>
    <HistoryFormer
      :show.sync="historyVisible"
      :wellid="wellid"
      @selected="handleSelelect"
    ></HistoryFormer>
  </el-dialog>
</template>

<script>
import { applyNew, applyUpdate } from '@/service/getData'
import BaseSelect from '@/components/select/base_select'
import { ApplyItemCategoryMap } from '@/config/global'
import ItemTemplateSelect from '@/components/select/item_template_select'
import ProductSelect from '@/components/select/product_select.vue'
import ItemSelect from '@/components/select/item_select.vue'
import AttachmentUpload from '@/components/AttachmentUpload.vue'
import HistoryFormer from './history_former.vue'

export default {
  components: {
    BaseSelect,
    ItemTemplateSelect,
    ProductSelect,
    ItemSelect,
    AttachmentUpload,
    HistoryFormer,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.form = {}
        this.$refs.form.resetFields()
      }
    },
    'form.entity_type': function (n) {
      if ([1, 2].includes(n)) {
        this.form.drill_well_id = ''
      }
    },
    // 'form.base_id': function (n, o) {
    //   if (o) {
    //     this.form.items = []
    //   }
    // },
    // 'form.drill_well_id': function (n, o) {
    //   if (o) {
    //     this.form.items = []
    //   }
    // },
  },
  computed: {
    wellid() {
      return [1, 2].includes(this.form.entity_type)
        ? 0
        : this.form.drill_well_id || 0
    },
  },
  data() {
    return {
      ApplyItemCategoryMap,
      submitting: false,
      formData: {
        entity_type: 1,
        type: 2,
        category: '',
        delivery_category: '',
        base_id:
          this.$store.state.userInfo.base_id > 1
            ? this.$store.state.userInfo.base_id
            : '',
        approve_base_id: '',
        drill_well_id: '',
        receive_well_id: '',
        items: [],
        remark: '',
        attachments: [],
      },
      form: {},
      visible: this.show,
      historyVisible: false,
      addItemCount: 1,
      rules: {
        base_id: [
          { required: true, message: '请选择发起基地', trigger: 'change' },
          {
            type: 'number',
            message: '请选择发起基地',
            min: 1,
            trigger: 'change',
          },
        ],
        approve_base_id: [
          { required: true, message: '请选择接收基地', trigger: 'change' },
          {
            type: 'number',
            message: '请选择接收基地',
            min: 1,
            trigger: 'change',
          },
          ,
        ],
        drill_well_id: [
          { required: true, message: '请选择发起钻井', trigger: 'change' },
          {
            type: 'number',
            message: '请选择发起钻井',
            min: 1,
            trigger: 'change',
          },
        ],
        receive_well_id: [
          { required: true, message: '请选择接收钻井', trigger: 'change' },
          {
            type: 'number',
            message: '请选择接收钻井',
            min: 1,
            trigger: 'change',
          },
        ],
        category: [
          { required: true, message: '请选择单据类型', trigger: 'change' },
        ],
        send_date: [
          { required: true, message: '发出时间不能为空', trigger: 'change' },
        ],
        product_id: [
          { required: true, message: '请选择物资', trigger: 'change' },
        ],
        item_id: [{ required: true, message: '请选择物资', trigger: 'change' }],
        delivery_category: [
          { required: true, message: '请选择发货方式', trigger: 'change' },
        ],
        used_date: [
          { required: true, message: '工作时长不能为空', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '工作时长不能为0',
            trigger: 'blur',
          },
        ],
        return_reason: [
          { required: true, message: '返厂原因不能为空', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.form = this.formData
  },
  methods: {
    handleOpen() {
      this.addItemCount = 1
      if (this.model && this.model.id) {
        this.form = this.model
      } else {
        this.form = this.clone(this.formData)
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      }
    },
    handleSelectApply() {
      if ([3, 4].includes(this.form.entity_type) && !this.form.drill_well_id) {
        this.$alert('请先选择发起钻井！')
        return
      }
      this.historyVisible = true
    },
    handleInfo(e, index, cateName = '') {
      if (!e) return
      let exist =
        this.form.items.filter(
          (item) =>
            item[`${cateName}_id`] == e.id ||
            (e.code_type == 2 &&
              item.product_template_id == e.product_template_id &&
              item.product.code == e.code),
        ).length > 1
      if (exist) {
        this.form.items[index][`${cateName}_id`] = ''
        if (cateName == 'item') {
          this.$refs.itemSelect.clearSelected()
        }
        this.$message.error('该物资已添加')
        return
      }
      if (e.code_type != 2) {
        this.form.items[index].number = 0
      } else if (!this.form.items[index].number) {
        this.form.items[index].number = 1
      }

      if (e.product_template_id) {
        this.form.items[index].product_template_id = e.product_template_id
      }
      if (e.item_template_id) {
        this.form.items[index].item_template_id = e.item_template_id
      }
      const { spec, saleby, feature1 } = this.getCustomParam(e, cateName)
      this.$set(this.form.items[index], 'spec', spec)
      this.$set(this.form.items[index], 'saleby', saleby)
      this.$set(this.form.items[index], 'feature1', feature1)
      if (!this.form.items[index].remark && e.stock_type == 0) {
        this.$set(this.form.items[index], 'remark', e.remark)
      }
    },

    getCustomParam(model, cateName) {
      let result = {
        spec: '',
        saleby: '',
        feature1: '',
      }
      if (model) {
        const p = model.custom_params.filter((item) =>
          ['销售地'].includes(item.label),
        )[0]
        result.saleby = p ? p.value : ''

        const feature1 = model.custom_params.filter((item) =>
          ['特性1'].includes(item.label),
        )[0]
        result.feature1 = feature1 ? feature1.value : ''

        if (cateName == 'item') {
          result.spec = model.model_number
        } else {
          let names = ['规格型号', '规格', '型号']
          if (model.template.custom_params) {
            let modelAliasParam = model.template.custom_params.find(
              (param) => param.model_alias,
            )
            if (modelAliasParam) {
              names = [modelAliasParam.label]
            }
          }
          const p = model.custom_params.filter((item) =>
            names.includes(item.label),
          )[0]
          result.spec = p ? p.value : ''
        }
      }
      return result
    },

    submitForm() {
      if (this.submitting) return
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          if (this.form.id > 0) {
            let res = await applyUpdate(this.form)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
            this.submitting = false
          } else {
            let res = await applyNew(this.form)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
            this.submitting = false
          }
        } else {
          return false
        }
      })
    },

    handleSelelect(supply) {
      let items = []
      supply.items.map((item) => {
        let condition1 =
          item.category == 3 &&
          item.product.status == 2 &&
          item.product.receive_base_id == 0 &&
          item.product.receive_well_id == 0 &&
          item.product.drill_well_id == this.wellid &&
          item.product.base_id == this.form.base_id
        let condition2 =
          item.category == 4 &&
          item.item.status == 1 &&
          item.item.receive_base_id == 0 &&
          item.item.receive_well_id == 0 &&
          item.item.drill_well_id == this.wellid &&
          item.item.base_id == this.form.base_id
        if (condition1 || condition2) {
          const { spec, saleby, feature1 } = this.getCustomParam(
            item.product_id ? item.product : item.item,
            item.product_id ? 'product' : 'item',
          )
          items.push({
            category: item.category,
            product_template_id: item.product_template_id,
            item_template_id: item.item_template_id,
            product_id: item.product_id,
            item_id: item.item_id,
            remark: item.remark,
            used_date: item.used_date,
            return_reason: item.return_reason,
            spec: spec,
            saleby: saleby,
            feature1: feature1,
            number: item.number,
          })
        }
      })

      this.form.items = this.form.items.concat(items)
    },

    handleAddItem() {
      if (!this.form.base_id && !this.form.drill_well_id) {
        this.$alert('请先选择发起地！')
        return
      }

      if (!this.addItemCount) {
        this.addItemCount = 1
      }

      let items = []
      for (let index = 0; index < this.addItemCount; index++) {
        items.push({
          category: 3,
          product_template_id: '',
          item_template_id: '',
          product_id: '',
          item_id: '',
          remark: '',
          used_date: 1,
          return_reason: '',
          number: 0,
        })
      }

      this.form.items = this.form.items.concat(items)

      // this.$nextTick(() => {
      //   this.$refs['category'].focus()
      // })
    },
  },
}
</script>

<style scoped>
/deep/.el-table .cell .el-form-item {
  margin-bottom: 0 !important;
}

/deep/.el-input-number--mini {
  width: 60px;
}

.supply-form {
  display: flex;
  flex-wrap: wrap;
}

.supply-form .el-form-item {
  width: 50%;
}
</style>
